import { Link } from 'react-router-dom'
import { ADDRESS_UI } from '../constants/addresses'
import { useAddressEdit } from '../hooks/useAddressEdit'
import '../styles/addresses-page.scss'

export function AddressEditPage() {
  const { loading, missing, draft, updateDraft, saving, error, returnTo, backLabel, onSubmit } =
    useAddressEdit()

  return (
    <div className="addresses-page">
      <header className="addresses-page__head">
        <h1>{ADDRESS_UI.editTitle}</h1>
        <p>{ADDRESS_UI.editLead}</p>
      </header>

      <p className="addresses-page__back">
        <Link to={returnTo}>{backLabel}</Link>
      </p>

      {error ? <p className="addresses-page__error">{error}</p> : null}

      {loading ? <p className="addresses-page__hint">{ADDRESS_UI.loading}</p> : null}

      {missing ? <p className="addresses-page__hint">{ADDRESS_UI.missing}</p> : null}

      {draft ? (
        <form className="addresses-page__form" onSubmit={(event) => void onSubmit(event)}>
          <label>
            <span>{ADDRESS_UI.name}</span>
            <input
              value={draft.recipientName}
              onChange={(event) => updateDraft({ recipientName: event.target.value })}
              required
              maxLength={160}
              disabled={saving}
            />
          </label>
          <label>
            <span>{ADDRESS_UI.phone}</span>
            <input
              type="tel"
              inputMode="numeric"
              value={draft.recipientPhone}
              onChange={(event) =>
                updateDraft({
                  recipientPhone: event.target.value.replace(/\D/g, '').slice(0, 10),
                })
              }
              required
              minLength={10}
              maxLength={10}
              disabled={saving}
            />
          </label>
          <label className="addresses-page__wide">
            <span>{ADDRESS_UI.address}</span>
            <textarea
              value={draft.address}
              onChange={(event) => updateDraft({ address: event.target.value })}
              required
              maxLength={500}
              rows={2}
              disabled={saving}
            />
          </label>
          <label>
            <span>{ADDRESS_UI.city}</span>
            <input
              value={draft.city}
              onChange={(event) => updateDraft({ city: event.target.value })}
              required
              maxLength={120}
              disabled={saving}
            />
          </label>
          <label>
            <span>{ADDRESS_UI.pincode}</span>
            <input
              inputMode="numeric"
              value={draft.pincode}
              onChange={(event) =>
                updateDraft({ pincode: event.target.value.replace(/\D/g, '').slice(0, 12) })
              }
              required
              maxLength={12}
              disabled={saving}
            />
          </label>
          <button type="submit" disabled={saving}>
            {saving ? ADDRESS_UI.saving : ADDRESS_UI.save}
          </button>
        </form>
      ) : null}
    </div>
  )
}
